module.exports = __webpack_public_path__ + "assets/images/mirror-01.6c2fef9b14751805f7033f11e2d188fe.svg";